import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getPackagesRequest = () => {
    const config = {
        path: 'packages',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}